import React from 'react';
import errorStyles from '../../assets/css/error.module.css';
import { WithChildren } from '../../types/utility';
import { selectError } from '../../app/slices/error.slice';
import { useAppSelector } from '../../app/hooks';
import { AppError } from '../../types/error';
import { TechnicalErrorIcon } from '../svgs/TechnicalErrorIcon';
import { InternalErrorFallbackComponent } from './TechErrorBoundary';

export const AppErrorBoundary = ({ children }: WithChildren) => {
	const error = useAppSelector(selectError);
	if (error.raised) return <AppErrorFallbackComponent error={error} />;
	return <React.Fragment>{children}</React.Fragment>;
};

interface AppErrorProps {
	error: AppError;
}

export const AppErrorFallbackComponent = ({ error }: AppErrorProps) => {
	if (error.type === 'INTERNAL_SERVER') return <InternalErrorFallbackComponent />;

	const title = error.type + ' ERROR';
	return (
		<div className={errorStyles['error-container']}>
			<div className={errorStyles['error-content']}>
				<div className={errorStyles['error-icon']}>
					<TechnicalErrorIcon key="technical-error-icon" />
				</div>
				<div className={errorStyles['error-title']} aria-label="error=title">
					{title}
				</div>
				<div className={errorStyles['error-text-container']}>
					<p className={errorStyles['error-text']} aria-label="error-message">
						{error.message}
					</p>
				</div>
			</div>
		</div>
	);
};
